import React from 'react';
import styled from 'styled-components';

import ErrorIcon from '../icons/alert-error';

const AlertComponent = ({ children }) => (
  <AlertWrapper>
    <ErrorIcon />
    {children}
  </AlertWrapper>
);

const AlertWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 0.8rem;
  background-color: #ffc0be;
  padding: 0.8rem 1.4rem;
  color: #333333;
  font-size: 1.4rem;
  margin-bottom: 2.4rem;

  & > svg {
    width: 1.6rem;
    height: 1.6rem;
    margin-right: 0.6rem;
  }
`;

export default AlertComponent;
